export default __webpack_public_path__ + "static/media/4.9acd8469.png";